/* ============================================================================
   SNAPGOODY — SITE CHROME
   Header (transparent → solid) · mega menus · mobile nav · search · hero
   slideshow · footer · region switcher
   ----------------------------------------------------------------------------
   Header and footer are rendered from one place so every page is identical.
   In the Shopify build these become sections/header.liquid and
   sections/footer.liquid — the markup is a 1:1 match.
   ========================================================================== */
(function (global) {
  'use strict';
  var SG = global.SG;
  var $ = SG.$, $$ = SG.$$;

  var C = function () { return global.SG_CONTENT || {}; };

  /* ================================================================ WORDMARK ==
     Order of preference: a merchant-supplied image, the inline vector wordmark,
     then plain text. The vector is inlined rather than used as an <img> so that
     fill="currentColor" flips it white → black with the header state.
     ======================================================================== */
  function brandMark(b) {
    b = b || {};
    if (b.logo) return '<img src="' + SG.resolveSrc(b.logo) + '" alt="' + SG.esc(b.name || 'Snapgoody') + '">';
    if (global.SG_LOGO) return global.SG_LOGO;
    return SG.esc(b.name || 'Snapgoody');
  }

  /* ================================================================== MENUS ==*/
  function menuData() {
    var cat = SG.catalog;
    var col = function (h) {
      var c = cat.collection(h);
      return {
        title: c.title,
        href: SG.url('collection.html?c=' + h),
        links: cat.inCollection(h).slice(0, 7).map(function (p) {
          return { label: p.title, href: SG.url('product.html?p=' + p.handle) };
        })
      };
    };
    return [
      {
        id: 'shop',
        label: 'Shop',
        href: SG.url('collection.html?c=top'),
        /* Order matters: the first three match the first three collection
           banners in the homepage slideshow (content/site.js → hero.slides). */
        columns: [col('home-lifestyle'), col('top'), col('accessories'), col('apple')],
        feature: {
          slot: 'nav.feature-shop',
          title: 'The Leather Duo',
          text: 'Case and MagSafe wallet, sold only as a pair.',
          href: SG.url('product.html?p=leather-case-magsafe-duo')
        }
      }
    ];
  }

  /* ================================================================= HEADER ==*/
  function headerHTML() {
    var b = C().brand || {};
    var menus = menuData();

    var navHTML = menus.map(function (m) {
      return '<a class="nav-link" href="' + m.href + '" data-menu="' + m.id + '">' + SG.esc(m.label) +
        SG.icon('chevron', 'nav-link__chev') + '</a>';
    }).join('') +
      '<a class="nav-link nav-link--accent" href="' + SG.url('fitting-room.html') + '">Fitting Room</a>';

    var logo = brandMark(b);

    var mega = menus.map(function (m) {
      var cols = m.columns.map(function (c) {
        return '<div class="megamenu__col"><h4><a href="' + c.href + '">' + SG.esc(c.title) + '</a></h4><ul>' +
          c.links.map(function (l) { return '<li><a href="' + l.href + '">' + SG.esc(l.label) + '</a></li>'; }).join('') +
          '</ul></div>';
      }).join('');
      var feat = m.feature ? '<a class="megamenu__feature" href="' + m.feature.href + '">' +
        SG.media(m.feature.slot, { compact: true }) +
        '<h5>' + SG.esc(m.feature.title) + '</h5><p>' + SG.esc(m.feature.text) + '</p></a>' : '';
      return '<div class="megamenu" data-menu-panel="' + m.id + '"><div class="megamenu__inner">' + cols + feat + '</div></div>';
    }).join('');

    return '' +
      '<div class="header__inner">' +
        '<button class="burger" type="button" aria-label="Menu" data-burger><span></span></button>' +
        '<nav class="header__nav" aria-label="Primary">' + navHTML + '</nav>' +
        '<a class="header__logo" href="' + SG.url('index.html') + '" data-logo>' + logo + '</a>' +
        '<div class="header__actions">' +
          '<span class="header__region">' + SG.icon('globe') +
            '<select data-region aria-label="Region">' +
              Object.keys(SG.regions).map(function (k) {
                return '<option value="' + k + '">' + k + '</option>';
              }).join('') +
            '</select>' +
          '</span>' +
          '<button class="icon-btn" type="button" aria-label="Search" data-search-open>' + SG.icon('search') + '</button>' +
          /* SG.accountUrl() is the static account page here and Shopify's own
             customer account route in the theme — see theme-bridge.js. */
          '<a class="icon-btn" href="' + SG.accountUrl() + '" aria-label="Account">' + SG.icon('user') + '</a>' +
          '<button class="icon-btn" type="button" aria-label="Bag" data-cart-open>' + SG.icon('bag') +
            '<span class="icon-btn__count" data-cart-count>0</span></button>' +
        '</div>' +
      '</div>' + mega;
  }

  function searchHTML() {
    return '<div class="searchbar" data-searchbar>' +
      '<div class="searchbar__inner">' +
        SG.icon('search') +
        '<input type="search" placeholder="Search for a piece…" aria-label="Search" data-search-input>' +
        '<button class="icon-btn" type="button" aria-label="Close search" data-search-close>' + SG.icon('close') + '</button>' +
      '</div>' +
      '<div class="searchbar__results" data-search-results></div>' +
    '</div>';
  }

  function mobileNavHTML() {
    var menus = menuData();
    var items = menus.map(function (m) {
      return '<div class="mobilenav__item"><button class="mobilenav__head" type="button">' + SG.esc(m.label) + SG.icon('plus') + '</button>' +
        '<div class="mobilenav__panel">' +
          m.columns.map(function (c) {
            return '<a href="' + c.href + '"><strong>' + SG.esc(c.title) + '</strong></a>' +
              c.links.map(function (l) { return '<a href="' + l.href + '">' + SG.esc(l.label) + '</a>'; }).join('');
          }).join('') +
        '</div></div>';
    }).join('');
    /* Secondary row — the help pages the header has no room for on a phone. */
    var secondary = [
      { label: 'Your account',        href: 'account.html' },
      { label: 'Shipping & delivery', href: 'page.html?p=shipping-delivery' },
      { label: 'Returns & remakes',   href: 'page.html?p=returns' },
      { label: 'Contact',             href: 'page.html?p=contact' }
    ].map(function (l) {
      return '<a href="' + SG.url(l.href) + '">' + SG.esc(l.label) + '</a>';
    }).join('');

    return '<div class="mobilenav" data-mobilenav><div class="mobilenav__body">' + items +
      '<div class="mobilenav__item"><a class="mobilenav__head" href="' + SG.url('fitting-room.html') + '" style="color:var(--clay)">Fitting Room</a></div>' +
      '<div class="mobilenav__secondary">' + secondary + '</div>' +
      '</div><div class="mobilenav__foot">' +
      '<a class="btn btn--ghost btn--block" href="' + SG.url('fitting-room.html') + '">Start customising</a>' +
      '</div></div>';
  }

  /* ================================================================= FOOTER ==*/
  /* Social icons render only where a profile URL is configured in
     content/site.js, so an unfilled handle never ships as a dead link. */
  function socialHTML(f) {
    var list = (f.social || []).filter(function (s) { return s && s.href; });
    if (!list.length) return '';
    return '<div class="footer__social">' + list.map(function (s) {
      return '<a href="' + s.href + '" aria-label="' + SG.esc(s.label) + '"' +
        ' target="_blank" rel="noopener noreferrer">' + SG.icon(s.icon) + '</a>';
    }).join('') + '</div>';
  }

  function footerHTML() {
    var f = C().footer || {}, b = C().brand || {};
    var cols = (f.columns || []).map(function (c) {
      return '<div class="footer__col"><h4>' + SG.esc(c.title) + '</h4><ul>' +
        c.links.map(function (l) { return '<li><a href="' + (/^(https?:|#)/.test(l.href) ? l.href : SG.url(l.href)) + '">' + SG.esc(l.label) + '</a></li>'; }).join('') +
        '</ul></div>';
    }).join('');
    var n = f.newsletter || {};
    return '<div class="wrap">' +
      '<div class="footer__top">' +
        '<div class="footer__brand">' +
          '<a class="wordmark" href="' + SG.url('index.html') + '">' + brandMark(b) + '</a>' +
          '<p>' + SG.esc(f.blurb || '') + '</p>' +
          socialHTML(f) +
        '</div>' + cols +
        '<div class="footer__news"><h4>' + SG.esc(n.title || '') + '</h4><p>' + SG.esc(n.text || '') + '</p>' +
          '<form class="footer__form" data-newsletter>' +
            '<input type="email" placeholder="Email address" aria-label="Email address" required>' +
            '<button type="submit">Join</button>' +
          '</form>' +
        '</div>' +
      '</div>' +
      '<div class="footer__bottom">' +
        '<span>© ' + new Date().getFullYear() + ' ' + SG.esc(b.name || 'Snapgoody') + '. All rights reserved.</span>' +
        '<nav>' + (f.legal || []).map(function (l) {
          /* Tolerates the old ['Privacy', …] shape as well as {label, href}. */
          var label = typeof l === 'string' ? l : l.label;
          var href = typeof l === 'string' ? '' : l.href;
          return href ? '<a href="' + SG.url(href) + '">' + SG.esc(label) + '</a>'
                      : '<span>' + SG.esc(label) + '</span>';
        }).join('') + '</nav>' +
      '</div>' +
    '</div>';
  }

  /* ================================================================== MOUNT ==*/
  var chrome = {};

  chrome.mount = function () {
    var host = $('[data-site-header]');

    /* In the Shopify build the header, search bar, mobile nav, announcement
       and footer are rendered by Liquid sections. They carry data-prerendered,
       so we only attach behaviour. */
    if (host && host.hasAttribute('data-prerendered')) {
      if (!host.__mounted) { host.__mounted = true; bindHeader(host); }
      var pf = $('[data-site-footer]');
      if (pf && !pf.__mounted) {
        pf.__mounted = true;
        var pform = $('[data-newsletter]', pf);
        if (pform) pform.addEventListener('submit', function (e) {
          e.preventDefault(); pform.reset(); SG.toast('Thank you — you are on the list.', 'check');
        });
      }
      return;
    }

    if (host && !host.__mounted) {
      host.__mounted = true;
      host.className = 'header';
      host.innerHTML = headerHTML();

      /* announcement bar */
      var a = (C().announcement || {});
      if (a.show) {
        var bar = SG.el('div', { class: 'announce' },
          SG.esc(a.text) + (a.linkText ? ' &nbsp;<a href="' + SG.url(a.href || '#') + '">' + SG.esc(a.linkText) + '</a>' : ''));
        document.body.insertBefore(bar, document.body.firstChild);
        document.body.classList.add('has-announce');
      }

      document.body.insertAdjacentHTML('afterbegin', searchHTML());
      document.body.insertAdjacentHTML('afterbegin', mobileNavHTML());
      bindHeader(host);
    }

    var foot = $('[data-site-footer]');
    if (foot && !foot.__mounted) {
      foot.__mounted = true;
      foot.className = 'footer';
      foot.innerHTML = footerHTML();
      var form = $('[data-newsletter]', foot);
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault(); form.reset(); SG.toast('Thank you — you are on the list.', 'check');
      });
    }
  };

  /* ------------------------------------------------------------- behaviour --*/
  function bindHeader(header) {
    var closeTimer = null;

    function closeMenus() {
      $$('.megamenu', header).forEach(function (p) { p.classList.remove('is-open'); });
      $$('.nav-link', header).forEach(function (l) { l.classList.remove('is-active'); });
      header.classList.remove('is-open');
    }
    function openMenu(id) {
      clearTimeout(closeTimer);
      $$('.megamenu', header).forEach(function (p) {
        p.classList.toggle('is-open', p.getAttribute('data-menu-panel') === id);
      });
      $$('.nav-link', header).forEach(function (l) {
        l.classList.toggle('is-active', l.getAttribute('data-menu') === id);
      });
      header.classList.add('is-open');
    }

    $$('.nav-link[data-menu]', header).forEach(function (link) {
      var id = link.getAttribute('data-menu');
      link.addEventListener('mouseenter', function () { openMenu(id); });
      link.addEventListener('focus', function () { openMenu(id); });
    });
    $$('.megamenu', header).forEach(function (p) {
      p.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    });
    header.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(closeMenus, 140);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenus(); });

    /* — scroll state ------------------------------------------------------ */
    var announce = $('.announce');
    var last = global.scrollY;

    function announceHeight() { return announce ? announce.offsetHeight : 0; }
    function syncAnnounce() {
      var h = announceHeight();
      document.body.style.setProperty('--announce-h', h + 'px');
    }
    syncAnnounce();
    global.addEventListener('resize', SG.debounce(syncAnnounce, 120));

    var onScroll = function () {
      var y = global.scrollY;
      /* The header rides on top of the announcement bar until it scrolls away. */
      header.style.top = Math.max(0, announceHeight() - y) + 'px';
      var hero = $('[data-hero]');
      var threshold = hero ? Math.max(80, hero.offsetHeight - 140) : 40;
      header.classList.toggle('is-solid', y > threshold);
      /* Never hide the header while any part of the hero is still on screen —
         it has to stay visible over the banner. */
      var heroPassed = hero ? y > (hero.getBoundingClientRect().bottom + y) : true;
      if (!header.classList.contains('is-open')) {
        header.classList.toggle('is-hidden', heroPassed && y > last && y > threshold + 160);
      }
      last = y;
    };
    global.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* — burger ------------------------------------------------------------ */
    var burger = $('[data-burger]', header);
    var mobile = $('[data-mobilenav]');
    if (burger && mobile) {
      burger.addEventListener('click', function () {
        var on = !mobile.classList.contains('is-open');
        mobile.classList.toggle('is-open', on);
        burger.classList.toggle('is-on', on);
        header.classList.toggle('is-solid', on);
        SG.lockScroll(on);
      });
      $$('.mobilenav__item > button', mobile).forEach(function (btn) {
        btn.addEventListener('click', function () { btn.parentNode.classList.toggle('is-open'); });
      });
    }

    /* — search ------------------------------------------------------------ */
    var sb = $('[data-searchbar]');
    var input = $('[data-search-input]');
    var results = $('[data-search-results]');
    var openSearch = function (on) {
      if (!sb) return;
      sb.classList.toggle('is-open', on);
      if (on) setTimeout(function () { input.focus(); }, 220);
      else { input.value = ''; results.innerHTML = ''; }
    };
    var so = $('[data-search-open]', header);
    if (so) so.addEventListener('click', function () { openSearch(true); });
    var sc = $('[data-search-close]');
    if (sc) sc.addEventListener('click', function () { openSearch(false); });
    if (input) {
      input.addEventListener('input', SG.debounce(function () {
        var hits = SG.catalog.search(input.value);
        results.innerHTML = hits.map(function (p) {
          return '<a class="searchbar__hit" href="' + SG.url('product.html?p=' + p.handle) + '">' +
            SG.mediaProduct(p.handle, 0, { compact: true, title: p.title }) +
            '<div><strong>' + SG.esc(p.title) + '</strong><span>' + SG.money(p.price) + '</span></div></a>';
        }).join('');
      }, 140));
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') openSearch(false); });
    }

    /* — region ------------------------------------------------------------ */
    var sel = $('[data-region]', header);
    if (sel) {
      sel.value = SG.region;
      sel.addEventListener('change', function () {
        SG.region = sel.value;
        SG.emit('region', SG.region);
        SG.toast('Prices now shown for ' + SG.regions[SG.region].label + '.', 'globe');
      });
    }

    /* — cart --------------------------------------------------------------- */
    var co = $('[data-cart-open]', header);
    if (co) co.addEventListener('click', function () { SG.emit('cart:open'); });
  }

  /* =================================================================== HERO ==*/
  chrome.hero = function () {
    var host = $('[data-hero]');
    if (!host || host.__mounted) return;
    host.__mounted = true;

    /* Shopify build: the section already rendered the slides from its blocks. */
    if (host.hasAttribute('data-prerendered')) {
      chrome.bindHero(host, +(host.getAttribute('data-duration') || 6800));
      return;
    }

    var cfg = C().hero || { slides: [] };
    var slides = cfg.slides || [];
    var dur = cfg.duration || 6800;

    host.style.setProperty('--hero-dur', dur + 'ms');
    host.innerHTML =
      '<div class="hero__slides">' +
        slides.map(function (s, i) {
          var cta = '';
          if (s.primary || s.secondary) {
            cta = '<div class="hero__cta">' +
              (s.primary ? '<a class="btn btn--light" href="' + SG.url(s.primary.href) + '">' + SG.esc(s.primary.label) + '</a>' : '') +
              (s.secondary ? '<a class="btn btn--onimg" href="' + SG.url(s.secondary.href) + '">' + SG.esc(s.secondary.label) + '</a>' : '') +
              '</div>';
          }
          return '<div class="hero__slide' + (i === 0 ? ' is-active' : '') + '" data-slide="' + i + '">' +
            '<div class="hero__media">' + SG.media(s.slot, { wrap: false, dark: true, eager: i === 0 }) + '</div>' +
            '<div class="hero__scrim"></div>' +
            '<div class="hero__content"><div class="hero__text">' +
              '<span class="hero__eyebrow">' + SG.esc(s.eyebrow) + '</span>' +
              '<h1 class="hero__title">' + s.title + '</h1>' +
              (s.sub ? '<p class="hero__sub">' + SG.esc(s.sub) + '</p>' : '') +
              cta +
            '</div></div>' +
          '</div>';
        }).join('') +
      '</div>' +
      '<div class="hero__ui">' +
        '<div class="hero__dots">' + slides.map(function (s, i) {
          return '<button class="hero__dot' + (i === 0 ? ' is-active' : '') + '" type="button" data-dot="' + i + '" aria-label="Slide ' + (i + 1) + '"></button>';
        }).join('') + '</div>' +
        '<div class="hero__arrows">' +
          '<button class="hero__arrow" type="button" data-prev aria-label="Previous slide">' + SG.icon('arrowL') + '</button>' +
          '<button class="hero__arrow" type="button" data-next aria-label="Next slide">' + SG.icon('arrowR') + '</button>' +
        '</div>' +
      '</div>' +
      '<div class="hero__scroll"><span>Scroll</span><i></i></div>';

    chrome.bindHero(host, dur);
  };

  /* Slide behaviour, shared by the generated and the Liquid-rendered hero. */
  chrome.bindHero = function (host, dur) {
    dur = dur || 6800;
    host.style.setProperty('--hero-dur', dur + 'ms');

    var idx = 0, timer = null;
    var els = $$('.hero__slide', host);
    var dots = $$('.hero__dot', host);
    if (!els.length) return;

    function show(n) {
      idx = (n + els.length) % els.length;
      els.forEach(function (e, i) { e.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) {
        d.classList.remove('is-active', 'is-done');
        if (i === idx) { void d.offsetWidth; d.classList.add('is-active'); }
        else if (i < idx) d.classList.add('is-done');
      });
      restart();
    }
    function restart() { clearTimeout(timer); timer = setTimeout(function () { show(idx + 1); }, dur); }

    dots.forEach(function (d) { d.addEventListener('click', function () { show(+d.getAttribute('data-dot')); }); });
    var pv = $('[data-prev]', host), nx = $('[data-next]', host);
    if (pv) pv.addEventListener('click', function () { show(idx - 1); });
    if (nx) nx.addEventListener('click', function () { show(idx + 1); });

    host.addEventListener('mouseenter', function () { clearTimeout(timer); });
    host.addEventListener('mouseleave', restart);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearTimeout(timer); else restart();
    });

    /* swipe */
    var x0 = null;
    host.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    host.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 48) show(idx + (dx < 0 ? 1 : -1));
      x0 = null;
    });

    restart();
  };

  /* ============================================================== ACCORDIONS ==*/
  chrome.accordions = function (root) {
    $$('.acc__head', root || document).forEach(function (h) {
      if (h.__bound) return; h.__bound = true;
      h.addEventListener('click', function () { h.parentNode.classList.toggle('is-open'); });
    });
  };

  /* ==================================================================== BOOT ==*/
  chrome.boot = function () {
    chrome.mount();
    chrome.hero();
    chrome.accordions();
    SG.reveal();
    SG.on('region', function () {
      $$('[data-price]').forEach(function (n) {
        n.textContent = SG.money(+n.getAttribute('data-price'));
      });
      SG.emit('rerender');
    });
  };

  SG.chrome = chrome;
}(window));
